import { useMemo } from 'react'
import {
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableHeader,
	TableRow,
} from '@/components/ui/table'
import type { PersonTimelineCartaoAmarelo } from '@/types'
import { formatDateToDisplay } from '@/utils/formatDate'
import { TimelineEmptyState } from '../person-timeline-modal'
import { groupByKindAndRisk } from './group-by-kind-and-risk'
import { KindRiskTable } from './kind-risk-table'

export function CartaoAmareloTimelineSection({
	data,
}: {
	data: PersonTimelineCartaoAmarelo
}) {
	const kindRiskGroups = useMemo(
		() => groupByKindAndRisk(data.items),
		[data.items],
	)

	return (
		<div className="flex flex-col gap-4">
			<KindRiskTable title="Por tipo e risco" groups={kindRiskGroups} />

			{data.items.length === 0 ? (
				<TimelineEmptyState label="Nenhum Cartão Amarelo registrado no período." />
			) : (
				<div className="rounded-lg border border-kaefer-light-silver">
					<Table className="table-fixed">
						<TableHeader>
							<TableRow className="bg-muted/30">
								<TableHead className="w-24">Data</TableHead>
								<TableHead className="w-32">Tipo</TableHead>
								<TableHead className="w-32">Risco</TableHead>
								<TableHead>Descrição</TableHead>
							</TableRow>
						</TableHeader>
						<TableBody>
							{data.items.map((item) => (
								<TableRow key={item.id}>
									<TableCell className="whitespace-nowrap text-muted-foreground">
										{formatDateToDisplay(item.date)}
									</TableCell>
									<TableCell className="whitespace-normal wrap-break-word">
										{item.kindName}
									</TableCell>
									<TableCell className="whitespace-normal wrap-break-word">
										{item.riskName}
									</TableCell>
									<TableCell className="whitespace-normal wrap-break-word text-muted-foreground">
										{item.description}
									</TableCell>
								</TableRow>
							))}
						</TableBody>
					</Table>
				</div>
			)}
		</div>
	)
}
